import React from 'react'
import AppModal from '../common/AppModal'
import SetupCompanyForm from '../../forms/SetupCompanyForm'

interface SetupCompanyModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const SetupCompanyModal: React.FC<SetupCompanyModalProps> = ({ open, onClose, loading, error }) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title="Register New Workspace"
      width="lg"
      loading={loading}
    >
      <SetupCompanyForm loading={loading} error={error} />
    </AppModal>
  )
}
export default SetupCompanyModal
